import React from "react";
import { Table } from "semantic-ui-react";

export const professionalContent = (
  <Table className={"coverage-area-table"}>
    <Table.Body>
      <Table.Row>
        <Table.HeaderCell colSpan={4}>Professional Licenses</Table.HeaderCell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Arkansas*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Alaska*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Arizona*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Arkansas*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>California</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Colorado</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Connecticut*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Delaware*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>District Of Columbia*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Florida</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Georgia</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Hawaii*</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Idaho*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Illinois</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Indiana</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Iowa</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Kansas*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Kentucky*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Louisiana*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Maine*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Maryland*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Massachusetts*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Michigan</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Minnesota</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Mississippi*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Missouri*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Montana*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Nebraska</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Nevada*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>New Hampshire*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>New Jersey*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>New Mexico*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>New York*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>North Carolina*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>North Dakota*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Ohio*</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Oklahoma</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Oregon*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Pennsylvania</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Rhode Island*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>South Carolina</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>New Hampshire*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>South Dakota*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Tennessee*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Texas</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Utah*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Vermont*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Virginia</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Washington*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>West Virginia*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Wisconsin</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Wyoming</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell colSpan={4} className={"red-text"}>
          * Only historical data available
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
);

export default professionalContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/Professional.js